<template>
  <div class="container">
    <van-image
      class="main-back"
      fit="cover"
      :src="require('@/assets/zj-back.png')"
    />
    <div class="main-wrap">
      <div class="title">丽企之家机构认证</div>
      <div class="name">{{ entName }}</div>
      <div class="interests">
        <div class="interests-title">认证机构权益</div>
        <div class="interests-col">
          <div class="interests-col-list">
            <van-image
              class="interests-col-list-icon"
              fit="contain"
              :src="require('@/assets/zj-pic4.png')"
            />
            <div class="interests-col-list-text">
              中小企业<br />服务中心认证
            </div>
          </div>
          <div class="interests-col-list">
            <van-image
              class="interests-col-list-icon"
              fit="contain"
              :src="require('@/assets/zj-pic5.png')"
            />
            <div class="interests-col-list-text">
              发布商品<br />向企业提供服务
            </div>
          </div>
          <div class="interests-col-list">
            <van-image
              class="interests-col-list-icon"
              fit="contain"
              :src="require('@/assets/zj-pic6.png')"
            />
            <div class="interests-col-list-text">上传凭证<br />服务兑现</div>
          </div>
        </div>
      </div>
      <div class="interests">
        <div class="interests-title">认证机构流程</div>
        <div class="interests-point">
          <div class="interests-point-list">
            <van-image
              class="interests-point-list-icon"
              fit="contain"
              :src="require('@/assets/zj-pic1.png')"
            />
            <div class="interests-point-list-text">
              点击下方申请，填写机构入驻材料
            </div>
          </div>
          <div class="interests-point-list">
            <van-image
              class="interests-point-list-icon"
              fit="contain"
              :src="require('@/assets/zj-pic2.png')"
            />
            <div class="interests-point-list-text">等待管理员审核</div>
          </div>
          <div class="interests-point-list">
            <van-image
              class="interests-point-list-icon"
              fit="contain"
              :src="require('@/assets/zj-pic3.png')"
            />
            <div class="interests-point-list-text">
              机构认证成功！前往PC端发布商品
            </div>
          </div>
        </div>
      </div>
      <div class="status">
        <div class="status-head">普通机构认证</div>
        <van-image class="status-icon" fit="contain" :src="icon" />
        <div class="status-title">{{ text }}</div>
        <div class="status-tab">{{ tab }}</div>
        <van-button
          :plain="
            (organizationType == 1 && status == 1) ||
              status == 3 ||
              organizationType == 2
          "
          :type="
            organizationType == 1 && (status == 2 || status == 4)
              ? 'danger'
              : 'info'
          "
          @click="linkTap(1)"
          >{{ btnText }}</van-button
        >
      </div>
      <div
        class="status last"
        v-if="organizationType == 2 || (status == 3 && organizationType == 1)"
      >
        <div class="status-head">服务券机构认证</div>
        <van-image class="status-icon" fit="contain" :src="icon1" />
        <div class="status-title">{{ text1 }}</div>
        <div class="status-tab">{{ tab1 }}</div>
        <van-button
          :plain="status == 1 || status == 3"
          :type="
            organizationType == 2 && (status == 2 || status == 4)
              ? 'danger'
              : 'info'
          "
          @click="linkTap(2)"
          >{{ btnText1 }}</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { getLocalStorage } from '@utils'
import { checkStatus, checkSetting } from '@api/intermediary/index'
import { Toast } from 'vant'
export default {
  data() {
    return {
      id: '',
      status: '',
      entName: getLocalStorage('entName'),
      creditCode: getLocalStorage('creditCode'),
      organizationType: '',
      statusArr: [
        {
          icon: require('@/assets/zj-sh1.png'),
          text: '您好，当前暂未完机构认证！',
          tab: '',
          btnText: '点击认证'
        },
        {
          icon: require('@/assets/zj-sh2.png'),
          text: '您好，已提交认证，请等待管理员审核……',
          tab: '',
          btnText: '修改信息'
        },
        {
          icon: require('@/assets/zj-sh3.png'),
          text: '很遗憾，您的申请被驳回！',
          tab: '',
          btnText: '重新认证'
        },
        {
          icon: require('@/assets/zj-sh4.png'),
          text: '恭喜您，申请已通过',
          tab: '您可以前往PC端发布商品，向企业提供服务',
          btnText: '查看详情'
        },
        {
          icon: require('@/assets/zj-sh3.png'),
          text: '很遗憾，您的申请被退回！',
          tab: '',
          btnText: '重新认证'
        }
      ],
      text: '',
      icon: '',
      tab: '',
      btnText: '',
      text1: '',
      icon1: '',
      tab1: '',
      btnText1: ''
    }
  },
  watch: {
    $route(to, from) {
      if (from.path == '/intermediary/details') {
        this.checkStatus(1)
      }
    }
  },
  mounted() {
    this.checkStatus(1)
  },
  methods: {
    checkStatus(type) {
      checkStatus({ organizationType: type }).then(res => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          this.id = data[0].id || ''
          this.organizationType = data[0].organizationType
          if (this.organizationType == 2) {
            this.status = data[0].status
            this.icon = this.statusArr[3].icon
            this.text = '恭喜您，申请普通机构已通过'
            this.tab = this.statusArr[3].tab
            this.btnText = this.statusArr[3].btnText
            this.icon1 = this.statusArr[this.status].icon
            this.text1 =
              this.status == 3
                ? '恭喜您，申请服务券机构已通过'
                : this.statusArr[this.status].text
            this.tab1 = this.statusArr[this.status].tab
            this.btnText1 = this.statusArr[this.status].btnText
            if ((this.status == 2 || this.status == 4) && data[0].remarks) {
              this.tab1 = '备注：' + data[0].remarks
            }
          } else {
            this.status = data[0].status
            this.icon = this.statusArr[this.status].icon
            this.text =
              this.status == 3
                ? '恭喜您，申请普通机构已通过'
                : this.statusArr[this.status].text
            this.tab = this.statusArr[this.status].tab
            this.btnText = this.statusArr[this.status].btnText
            if ((this.status == 2 || this.status == 4) && data[0].remarks) {
              this.tab = '备注：' + data[0].remarks
            }
            if (this.status == 3) {
              this.icon1 = this.statusArr[0].icon
              this.text1 = this.statusArr[0].text
              this.tab1 = this.statusArr[0].tab
              this.btnText1 = this.statusArr[0].btnText
              // 当普通机构认证通过后，开启服务机构认证
              this.checkStatus(2)
            }
          }
        } else {
          Toast(msg)
        }
      })
    },
    linkTap(num) {
      let status = null
      if (num == 1 && this.organizationType == 2) {
        status = 3
      } else {
        if (this.organizationType == 1 && num == 2 && this.status == 3) {
          status = 0
        } else {
          status = this.status
        }
      }
      // 审核通过后，查看详情没有权限
      if (status === 3) {
        this.$router.push({
          path: `/intermediary/details?id=${this.id}&status=${status}&organizationType=${num}`
        })
        return
      }
      checkSetting({
        creditCode: this.creditCode,
        organizationType: num // 1 普通机构   2 服务机构
      }).then(res => {
        if (res.data.code == '0000') {
          this.$router.push({
            path: `/intermediary/details?id=${this.id}&status=${status}&organizationType=${num}`
          })
        } else {
          Toast(res.data.msg)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  min-height: 100vh;
  background: #f7f7f7;
  box-sizing: border-box;
  .main-back {
    width: 100%;
    height: 4.4rem;
    position: absolute;
    top: 0;
  }
  .main-wrap {
    width: 100%;
    padding: 30px 15px 20px;
    box-sizing: border-box;
    position: relative;
  }
  .title {
    color: #fff;
    font-size: 21px;
  }
  .name {
    color: #fff;
    font-size: 14px;
    margin-top: 15px;
    margin-bottom: 30px;
  }
  .interests {
    background: #fff;
    border-radius: 10px;
    margin-top: 15px;
    &-title {
      padding: 13px 15px;
      font-size: 16px;
      border-bottom: 1px solid #eee;
    }
    &-col {
      display: flex;
      padding: 10px 0 20px;
      &-list {
        flex: 1;
        text-align: center;
        &-icon {
          width: 70px;
          height: 70px;
        }
        &-text {
          font-size: 13px;
          margin-top: -6px;
        }
      }
    }
    &-point {
      padding: 4px 15px 20px;
      &-list {
        display: flex;
        margin-top: 20px;
        &-icon {
          width: 50px;
        }
        &-text {
          font-size: 14px;
          position: relative;
          left: -10px;
        }
      }
    }
  }
  .last {
    margin-bottom: 40px;
  }
  .status {
    background: #fff;
    padding: 10px 20px 20px;
    border-radius: 10px;
    margin-top: 15px;
    text-align: center;
    .status-icon {
      width: 44px;
      height: 44px;
    }
    &-head {
      text-align: left;
      font-size: 16px;
      margin-bottom: 5px;
    }
    &-title {
      font-size: 16px;
      vertical-align: middle;
      margin-top: 12px;
    }
    &-tab {
      font-size: 14px;
      color: #999;
      padding: 16px 0;
    }
    /deep/.van-button {
      width: 100%;
      letter-spacing: 1px;
    }
  }
}
</style>
